import { useEffect, useState } from 'react';
import { useStore } from '../context/StoreContext';
import service from '../services/cakeorders.service';

export function useCakeOrders(fetchAll = false) {
    const { activeStoreId } = useStore();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        service.fetchCakesWithListener(fetchAll, (data) => {
            setOrders(data);
            setLoading(false);
        });
        return () => service.stopListening();
    }, [fetchAll, activeStoreId]);

    return { orders, loading };
}
